export default "/images/my-urban.webp?6007b69beb177e880a8e5723514ab793";